"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
exports.__esModule = true;
exports.getLabelFromChildren = exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj.default = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
var getLabelFromChildren = function getLabelFromChildren(children) {
  var label = '';
  _react.Children.toArray(children).some(function (child, childIndex) {
    var islabelFormed = false; // for Array of children

    if (typeof child === 'string') {
      child.split(' ').some(function (chunk, chunkIndex) {
        label += "" + (childIndex === 0 && chunkIndex === 0 ? '' : '-') + chunk;
        if (chunkIndex === 1) islabelFormed = true;
        return islabelFormed; // for restricting key only for two word
      });
    }

    return islabelFormed || childIndex === 1;
  });
  return label.toLowerCase();
};
exports.getLabelFromChildren = getLabelFromChildren;
var _default = getLabelFromChildren;
exports.default = _default;